import React from 'react'

import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbInput from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbInputTextarea from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input_textarea'
import MDefaultform from '../m_defaultForm'
import { checkRequireLabel } from '../../../../../../utils/form/checkRequireLabel'
import { extractFields } from '../../../../../../utils/form/extractFields'

const MCancellation = ({ data }) => {
  const t = useTranslations()
  const formType = data.form_definition[0].identifier
  const fields = extractFields(data.form_definition[0].form_field)

  return (
    <MDefaultform
      buttonLabel="Widerruf absenden"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={data.form_recipient[0].identifier}
      formType={formType}
    >
      {({ register, errors }) => (
        <>
          {data.headline && <DfbHeadline headline={data.headline} headline_level="h3" add_class="m-Formblock-headline" />}
          {data.text && <DfbParagraph add_class="m-Formblock-text" text={data.text} />}

          {(fields.applicantfirstname || fields.applicantlastname) && (
            <div className="m-Formblock-input-half">
              {[fields.applicantfirstname, fields.applicantlastname].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                  />
                </div>
              ))}
            </div>
          )}
          {fields.applicantnumber && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.applicantnumber.identifier, {
                  required: fields.applicantnumber.required === 1 ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.applicantnumber.identifier]}
                errorMessage={errors?.[fields.applicantnumber.identifier]?.message}
                label={checkRequireLabel(fields.applicantnumber)}
                focused
              />
            </div>
          )}

          <div className="m-Formblock-input-half">
            {fields.applicantbirthdate && (
              <div className="m-Formblock-input">
                <DfbInput
                  {...register(fields.applicantbirthdate.identifier, {
                    required: fields.applicantbirthdate.required ? t('form.errorMessage.input') : false,
                  })}
                  type="date"
                  error={errors[fields.applicantbirthdate.identifier]}
                  errorMessage={errors?.[fields.applicantbirthdate.identifier]?.message}
                  label={`${fields.applicantbirthdate.label}${fields.applicantbirthdate.required === 1 ? '*' : ''}`}
                  focused
                />
              </div>
            )}

            {fields.applicantemail && (
              <div className="m-Formblock-input">
                <DfbInput
                  {...register(fields.applicantemail.identifier, {
                    required: fields.applicantemail.required ? t('form.errorMessage.input') : false,
                  })}
                  error={errors[fields.applicantemail.identifier]}
                  errorMessage={errors?.[fields.applicantemail.identifier]?.message}
                  label={`${fields.applicantemail.label}${fields.applicantemail.required === 1 ? '*' : ''}`}
                  type="email"
                  focused
                />
              </div>
            )}
          </div>

          {fields.message && (
            <div className="m-Formblock-input">
              <DfbInputTextarea
                {...register(fields.message.identifier, {
                  required: fields.message.required === 1 ? t('form.errorMessage.input') : false,
                })}
                label={`${fields.message.label}${fields.message.required === 1 ? '*' : ''}`}
                error={errors[fields.message.identifier]}
                errorMessage={errors?.[fields.message.identifier]?.message}
              />
            </div>
          )}
          <div className="m-Formblock-text">
            <DfbParagraph text={t('form.cancellation.privacyText')} />
          </div>
        </>
      )}
    </MDefaultform>
  )
}

export default MCancellation
